<template>
  <div id="HomeindexClient">
    <main-tabbar v-if="isRouterAlive"> </main-tabbar>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import MainTabBarClient from "../../components/content/maintabber/MainTabBarClient"; 
export default {
  name: "HomeindexClient",
  provide () {
    return {
        reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  components: {
    "main-tabbar": MainTabBarClient,
  },
  methods:{
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  }
};
</script>
  <style>
/* @import "~assets/css/css.css";
  @import "~assets/css/font-awesome.min.css"; */
.theme1 .el-main {
  position: relative;
  /* background: #ffffff; */
}
.el-menu-item,
.el-tooltip__popper {
  font-family: Arial, "Microsoft YaHei";
}

</style>
